const $ = require('jquery')

const { BREAKPOINT } = require('./api')

// =========================================================================
// Module: tab--dolphin club
// =========================================================================
const dolphinClub = {
  init () {
    dolphinClub.slider()
  },
  slider () {
    const _ = $('.dolphin-club__inner')

    _.slick({
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      draggable: true,
      nextArrow: '<span class="custom-icon--arr-right"></span>',
      prevArrow: '<span class="custom-icon--arr-left"></span>',
      responsive: [ {
        breakpoint: BREAKPOINT.TABLET,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      } ],
    })
    _.on('afterChange', function() {
      $(this).find('.slick-track').css('margin-left', '0')
    })

    $('.offer-link--kids a').on('click', function() {
      const _ = $('.dolphin-club__inner')
      _.slick('unslick')

      setTimeout(function() {
        _.slick({
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          draggable: true,
          nextArrow: '<span class="custom-icon--arr-right"></span>',
          prevArrow: '<span class="custom-icon--arr-left"></span>',
          responsive: [ {
            breakpoint: BREAKPOINT.TABLET,
            settings: {
              slidesToShow: 1,
              arrows: false,
            },
          } ],
        })
        _.on('afterChange', function() {
          $(this).find('.slick-track').css('margin-left', '0')
        })
      }, 0)
    })
  },
}

module.exports = dolphinClub



// WEBPACK FOOTER //
// ./src/modules/dolphinClub.js